import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@progress/kendo-angular-grid';
import { SharedModule } from 'src/app/shared/shared.module';
import { TenantConfigurationRoutingModule } from './tenant-configuration-routing.module';
import { TenantConfigurationComponent } from './tenant-configuration.component';
import { TenantCreationComponent } from './tenant-creation/tenant-creation.component';
import { TenantGridComponent } from './tenant-grid/tenant-grid.component';
import { TenantIdentityProviderComponent } from './tenant-identity-provider/tenant-identity-provider.component';
import { TenantLicensingComponent } from './tenant-licensing/tenant-licensing.component';
import { TenantSettingsComponent } from './tenant-settings/tenant-settings.component';
import { TenantWidgetSettingsComponent } from './tenant-widget-settings/tenant-widget-settings.component';


@NgModule({
  declarations: [TenantConfigurationComponent,
    TenantSettingsComponent,
    TenantWidgetSettingsComponent,
    TenantIdentityProviderComponent,
    TenantLicensingComponent,
    TenantCreationComponent,
    TenantGridComponent],
  imports: [
    CommonModule,
    TenantConfigurationRoutingModule,
    GridModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class TenantConfigurationModule { }
